// extracted by mini-css-extract-plugin
module.exports = {"page":"DefaultUnavailable_page__yOjVT","notfound":"DefaultUnavailable_notfound__1DUyQ"};